<!-- <div class="customer-support-mobile-toggle-container hidden-desktop">
  </div>
  <div id="customer-support-container" class="customer-support-container" [ngClass]="displayMobile ? '' : 'hidden-mobile'">
    <div class="end-end">
        <div class="mg-back-close-container end">
          <img class="customer-support-icon" (click)="openBottomSheet($event)" src="assets\images\close-black-icon.svg" alt="Close Icon" />
        </div>
    </div>
    <div class="customer-support-item">
      <img class="customer-support-icon" src="assets\images\card-support-phone-icon.svg" alt="Customer Support Phone Icon" />
      <span class="customer-support-content">
        <p class="customer-support-label">{{ labels?.stellar?.customerSupport?.phoneLabel }}</p>
        <a  [href]="labels.stellar.customerSupport.supportPhoneNumberHref || 'tel:800-513-5175'" class="customer-support-info">{{ labels?.stellar?.customerSupport?.supportPhoneNumber }}</a>
      </span>
    </div>
    <div class="customer-support-item">
      <img class="customer-support-icon" src="assets\images\card-help-support-icon.svg" alt="Customer Support Phone Icon" />
      <div class="customer-support-content">
        <p class="customer-support-label">{{ labels?.stellar?.customerSupport?.submitHelpRequest }}​</p>
        <ng-container *ngIf="(isMobile$ | async) else isNotMobile">
          <p class="customer-support-info"><a href="#" (click)="openDialog(labels?.stellar?.customerSupport?.supportUrl)">{{ labels?.stellar?.customerSupport?.onlineHelpForm }}</a></p>
        </ng-container>
        <ng-template  #isNotMobile>
          <p class="customer-support-info"><a href="{{ labels?.stellar?.customerSupport?.supportUrl }}" target="_blank">{{ labels?.stellar?.customerSupport?.onlineHelpForm }}</a></p>
        </ng-template>
      </div>
    </div>
    <div class="customer-support-item">
      <img class="customer-support-icon" src="assets\images\card-support-email-icon.svg" alt="Customer Support Phone Icon" />
      <div class="customer-support-content">
        <p class="customer-support-label">{{ labels?.stellar?.customerSupport?.emailLabel }}</p>
          <p class="customer-support-info"><a href="mailto:{{labels?.stellar?.customerSupport?.emailAddress}}">{{ labels?.stellar?.customerSupport?.emailAddress }}</a></p>
      </div>
    </div>
  </div> -->
<ng-container>
  <div class="customer-support-container">
    <button
      class="customer-support-btn"
      (click)="toggleSupportPanel()"
      #menuOrDrawer
      [ngStyle]="{
        background: isSupportPanelOpen
          ? 'var(--gray-alpha-800, rgba(26, 26, 26, 1))'
          : null
      }"
    >
      <img
        [src]="
          isSupportPanelOpen
            ? 'assets/images/customer-support-mobile.svg'
            : 'assets/images/customer-support-gen-head-phone-mic.svg'
        "
        alt="support-icon"
        [ngStyle]="{
          width: isSupportPanelOpen ? 'inherit' : null,
          height: isSupportPanelOpen ? 'inherit' : null
        }"
      />
    </button>
    <ng-container *ngIf="isSupportPanelOpen && (isMobile$ | async) === false">
      <div class="support-dropdown-menu" (click)="$event.stopPropagation()">
        <div class="phone-number-container">
          <div class="icon">
            <img
              src="assets\images\card-support-phone-icon.svg"
              alt="support-phone"
            />
          </div>
          <div class="support-details">
            <span class="legal-name">
              {{ labels?.stellar?.customerSupport?.phoneLabel }}
            </span>
            <span class="contact-method">
              <a
                [href]="
                  labels.stellar.customerSupport.supportPhoneNumberHref ||
                  'tel:800-513-5175'
                "
                class="customer-support-info"
                >{{ labels?.stellar?.customerSupport?.supportPhoneNumber }}</a
              >
            </span>
          </div>
        </div>
        <div class="help-form-container">
          <div class="icon">
            <img
              src="assets\images\card-help-support-icon.svg"
              alt="support-form"
            />
          </div>
          <div class="support-details">
            <span class="legal-name">
              {{ labels?.stellar?.customerSupport?.submitHelpRequest }}
            </span>
            <span class="contact-method">
              <a
                href="{{ labels?.stellar?.customerSupport?.supportUrl }}"
                target="_blank"
                >{{ labels?.stellar?.customerSupport?.onlineHelpForm }}</a
              >
            </span>
          </div>
        </div>
        <div class="email-link-container">
          <div class="icon">
            <img
              src="assets\images\card-support-email-icon.svg"
              alt="support-email"
            />
          </div>
          <div class="support-details">
            <span class="legal-name">
              {{ labels?.stellar?.customerSupport?.emailLabel }}
            </span>
            <span class="contact-method">
              <a
                href="mailto:{{ labels.stellar.customerSupport.emailAddress }}"
                >{{ labels.stellar.customerSupport.emailAddress }}</a
              >
            </span>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="isSupportPanelOpen && (isMobile$ | async)">
      <div
        [@slideInOutAnimation]="isSupportPanelOpen ? 'in' : 'out'"
        class="mobile-support-dropdown-menu"
      >
        <div class="top-bar">
          <div class="title-close-container" (click)="onClose()">
            <img
              src="assets\images\close-black-icon.svg"
              alt="close-icon"
              class="close-button"
            />
          </div>
        </div>
        <div class="support-details-container">
          <div class="phone-number-container">
            <div class="icon">
              <img
                src="assets\images\card-support-phone-icon.svg"
                alt="support-phone"
              />
            </div>
            <div class="support-details">
              <span class="legal-name">
                {{ labels?.stellar?.customerSupport?.phoneLabel }}
              </span>
              <span class="contact-method">
                <a
                  [href]="
                    labels.stellar.customerSupport.supportPhoneNumberHref ||
                    'tel:800-513-5175'
                  "
                  class="customer-support-info"
                  >{{ labels?.stellar?.customerSupport?.supportPhoneNumber }}</a
                >
              </span>
            </div>
          </div>
          <div class="help-form-container">
            <div class="icon">
              <img
                src="assets\images\card-help-support-icon.svg"
                alt="support-form"
              />
            </div>
            <div class="support-details">
              <span class="legal-name">
                {{ labels?.stellar?.customerSupport?.submitHelpRequest }}
              </span>
              <span class="contact-method">
                <a
                  href="{{ labels?.stellar?.customerSupport?.supportUrl }}"
                  target="_blank"
                  >{{ labels?.stellar?.customerSupport?.onlineHelpForm }}</a
                >
              </span>
            </div>
          </div>
          <div class="email-link-container">
            <div class="icon">
              <img
                src="assets\images\card-support-email-icon.svg"
                alt="support-email"
              />
            </div>
            <div class="support-details">
              <span class="legal-name">
                {{ labels?.stellar?.customerSupport?.emailLabel }}
              </span>
              <span class="contact-method">
                <a
                  href="mailto:{{
                    labels.stellar.customerSupport.emailAddress
                  }}"
                  >{{ labels.stellar.customerSupport.emailAddress }}</a
                >
              </span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="(isMobile$ | async) && isSupportPanelOpen">
    <div
      [@overlayFadeInOutAnimation]
      (click)="$event.stopPropagation()"
      class="overlay"
      [ngClass]="{ active: isSupportPanelOpen && (isMobile$ | async) }"
    ></div>
  </ng-container>
</ng-container>
